import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { useAuthorizedAxiosClient } from "../../../../common/axios"
import DialogHeader from "../../components/DialogHeader"

export default function DeleteWorkflowDialog({ open, onClose, workflow }) {
  const [isDeleting, setIsDeleting] = useState(false)
  const navigate = useNavigate()
  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleDeleteButtonClicked() {
    setIsDeleting(true)
    axios
      .delete(`/workflows/api/workflows/${workflow.id}/`)
      .then(() => {
        onClose(true)
        navigate("/workflows")
      })
      .finally(() => setIsDeleting(false))
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Delete Workflow" onClose={handleSoftClose} />
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete{" "}
          <Typography variant="strong-inline" component="span">
            {workflow.name}
          </Typography>
          ? This is not reversible.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isDeleting}
          onClick={handleDeleteButtonClicked}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
